import React, { useEffect, useState } from "react";

interface Option {
  value: string;
  label: string;
}

interface SelectInputProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: Option[];
  optional?: boolean;
  widthLabel?: string;
  widthSelect?: string;
  onFilledChange?: (filled: boolean) => void;
}

const SelectInput: React.FC<SelectInputProps> = ({
  label,
  name,
  value,
  onChange,
  options,
  optional = false,
  widthLabel = "w-[35%]",
  widthSelect = "w-[65%]",
  onFilledChange,
}) => {
  const [isFilled, setIsFilled] = useState(optional || value !== "");

  useEffect(() => {
    const filled = optional || value !== "";
    setIsFilled(filled);
    if (onFilledChange) {
      onFilledChange(filled);
    }
  }, [value, optional]);

  return (
    <div className="w-full flex mb-2 md:mb-4">
      <div className={`${widthLabel}`}>
        <label className="mb-[2px] md:mb-1">
          {label}
          {!optional && <span className="text-red-500">*</span>}
          {optional && (
            <span className="text-gray-400 text-xs md:text-sm"> Optional</span>
          )}
        </label>
      </div>
      <select
        name={name}
        value={value}
        onChange={(e) => {
          onChange(e);
          if (!optional && onFilledChange) {
            onFilledChange(e.target.value !== "");
          }
        }}
        className={`border-2 rounded-md text-xs md:text-sm p-1 md:p-2 cursor-pointer ${widthSelect} focus:outline-none focus:border-[#2fa9bf]`}
      >
        <option value="">Please select an option</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectInput;
